import axios from "axios";

export const axiosInstance = axios.create({
    baseURL: process.env.API_URL,
});

export const axiosInstanceV2 = axios.create({
    baseURL: process.env.API_URL_V2,
});

export const axiosInstanceV3 = axios.create({
    baseURL: process.env.API_URL_V3,
});

export const axiosCmsInstance = axios.create({
    baseURL: process.env.CMS_API_URL,
});

export const axiosCmsWebsiteInstance = axios.create({
    baseURL: process.env.STRAPI_WEBSITE_API_URL,
});
